
import * as React from 'react';
import { Fade, ProgressBar } from 'react-bootstrap';
import Spinner from 'react-spinkit';

export default class LoadingOverlay extends React.Component<any, any> {
    
    constructor(props:any) {
        super(props);
    }

    render() {
        return (
            <Fade in={this.props.visible} timeout={1000} unmountOnExit={true}>
                <div id="loadingOverlay">
                    <Spinner name="folding-cube" color="aqua"/>
                    {
                        this.props.showProgress == true ?
                        <ProgressBar striped bsStyle="info" now={this.props.progress} /> : null
                    }
                </div>
            </Fade>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/LoadingOverlay.tsx